/***** Begin bsEditLocationOverlay Scripts *****/

var bsEditLocationOverlay = {

    overlayTimeout: null,
    modalBox: ".bsEditLocationOverlay",
    progressOverlay: ".bsEditLocationOverlay .progress",
    progressDelayOverlay: ".bsEditLocationOverlay .progress .delay",
    glyphMapMarker: ".bsEditLocationOverlay .glyphicon-map-marker",
    glyphError: ".bsEditLocationOverlay .glyphicon-warning-sign",
    closeButton: ".bsEditLocationOverlay .close",
    zipTextBox: ".bsEditLocationOverlay .textBox",
    zipSaveButton: ".bsEditLocationOverlay .setLocation",
    currentLocationIcon: ".bsEditLocationOverlay .glyphicon-screenshot",
    currentLocationButton: ".bsEditLocationOverlay .currentLocation",
    errorRow: ".bsEditLocationOverlay #divErrorRow",
    errorRowGeo: ".bsEditLocationOverlay #divErrorRowGeoLocation",
    latitudeIdentifier: null,
    longitudeIdentifier: null,

    init: function () {
        $("form").bind("keypress", function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                return false;
            }
        });

        $(bsEditLocationOverlay.modalBox).on('shown.bs.modal', function (e) {
            $(bsEditLocationOverlay.closeButton).focus();
        });

        $(bsEditLocationOverlay.zipTextBox).on("focus", function (e) {
            $(this).val("");
        });

        $(bsEditLocationOverlay.zipTextBox).on("keypress keyup blur", function (e) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((e.which != 8) && (e.which < 48 || e.which > 57)) {
                e.preventDefault();
            }

            if ($(bsEditLocationOverlay.zipTextBox).val().length === 5) {
                $(bsEditLocationOverlay.zipTextBox).addClass("btnVisible");
                $(bsEditLocationOverlay.zipSaveButton).css("visibility", "visible");

                if (e.which == 13) {
                    bsEditLocationOverlay.submitZipCodeUpdate("ZipSave");
                }
            }
            else {
                $(bsEditLocationOverlay.zipTextBox).removeClass("btnVisible");
                $(bsEditLocationOverlay.zipSaveButton).css("visibility", "hidden");
            }
        });

        $(document).ready(function () {
            globalEvents.Event("userLocationUpdated").subscribe(function () { bsEditLocationOverlay.setUserLocation(); });
        });

        $(window).on("load", function () {
            bsEditLocationOverlay.setUserLocation();
        });
    },

    setUserLocation: function () {
        if ((bsCommon.userLocationJson() != null) && (bsCommon.userLocationJson() != "")) {
            if (bsCommon.userLocationJson().PostalCode != "") {
                $(bsEditLocationOverlay.zipTextBox).val(bsCommon.userLocationJson().PostalCode);
            }

            if ((bsCommon.userLocationJson().City != "") && (bsCommon.userLocationJson().Region != "")) {
                $(".bsEditLocationOverlay .cityState").html(bsCommon.userLocationJson().City.toLowerCase() + ", " + bsCommon.userLocationJson().Region);
            }
        }
    },

    submitZipCodeUpdate: function (method) {
        $(bsEditLocationOverlay.progressOverlay).css("display", "block");
        bsEditLocationOverlay.overlayTimeout = setTimeout(function () { $(bsEditLocationOverlay.progressDelayOverlay).css("display", "block"); }, 10000);

        var data = $("form").serializeArray();
        data.push({ name: "Method", value: method });

        if ((bsEditLocationOverlay.latitudeIdentifier !== null) && (bsEditLocationOverlay.longitudeIdentifier !== null)) {
            data.push({ name: "Latitude", value: bsEditLocationOverlay.latitudeIdentifier }, { name: "Longitude", value: bsEditLocationOverlay.longitudeIdentifier });
        }

        $.ajax({
            type: "POST",
            url: "/anon/handlers/ajaxactivity.ashx",
            dataType: "html",
            data: data,
            success: function (data, textStatus, request) {
                globalEvents.Event('locationUpdated').publish();

                if (request.getResponseHeader("location") != null) {
                    window.location.href = htmlEncode(request.getResponseHeader("location")); 
                }
                else {
                    bsEditLocationOverlay.reloadPage();
                }
            },
            statusCode:
            {
                500: function () {
                    if (method === "ZipSave") {
                        bsEditLocationOverlay.errorZipSave();
                    }
                    else {
                        bsEditLocationOverlay.errorDeviceGeoLocation();
                    }
                }
            },
            error: function (error) {
                if (method === "ZipSave") {
                    bsEditLocationOverlay.errorZipSave();
                }
                else {
                    bsEditLocationOverlay.errorDeviceGeoLocation();
                }
            }
        });
    },

    clearZipCodeLoadingOverlay: function () {
        clearTimeout(bsEditLocationOverlay.overlayTimeout);
        $(bsEditLocationOverlay.progressOverlay).css("display", "none");
        $(bsEditLocationOverlay.progressDelayOverlay).css("display", "none");
    },

    errorZipSave: function () {
        bsEditLocationOverlay.clearZipCodeLoadingOverlay();
        $(bsEditLocationOverlay.errorRow).css("display", "block");
        $(bsEditLocationOverlay.errorRowGeo).css("display", "none");
        $(bsEditLocationOverlay.zipSaveButton).css("visibility", "hidden").addClass("errorButton");
        $(bsEditLocationOverlay.zipTextBox).removeClass("btnVisible").addClass("error");
        $(bsEditLocationOverlay.glyphMapMarker).addClass("glyphicon-warning-sign");
    },

    getDeviceGeoLocation: function () {
        if (navigator.geolocation != null) {
            $(bsEditLocationOverlay.progressOverlay).css("display", "block");
            navigator.geolocation.getCurrentPosition(bsEditLocationOverlay.postDeviceGeoLocation, bsEditLocationOverlay.errorDeviceGeoLocation, { timeout: 7500 });
        }
        else {
            bsEditLocationOverlay.errorDeviceGeoLocation();
        }
    },

    postDeviceGeoLocation: function (position) {
        if ((position != undefined) && (position.coords.latitude != undefined) && (position.coords.longitude != undefined)) {
            bsEditLocationOverlay.latitudeIdentifier = position.coords.latitude;
            bsEditLocationOverlay.longitudeIdentifier = position.coords.longitude;

            bsEditLocationOverlay.submitZipCodeUpdate("ZipGeoLocation");
        }
        else {
            bsEditLocationOverlay.errorDeviceGeoLocation();
        }
    },

    errorDeviceGeoLocation: function () {
        bsEditLocationOverlay.clearZipCodeLoadingOverlay();
        $(bsEditLocationOverlay.divErrorRow).css("display", "none");
        $(bsEditLocationOverlay.errorRowGeo).css("display", "block");
        $(bsEditLocationOverlay.currentLocationIcon).css("visibility", "hidden");
        $(bsEditLocationOverlay.currentLocationButton).css("visibility", "hidden");
    },
    htmlEncode = function (str) {
        return String(str).replace(/[^\w. ]/gi, function (c) {
            return '&#' + c.charCodeAt(0) + ';';
        });
    },

  reloadPage: function()
  {
    if (document.forms[0].action.indexOf("AgentNumber=") > 0)
    {
      var query_arg_regex = new RegExp("AgentNumber=([0-9]*)");

      location.href = document.forms[0].action.replace(query_arg_regex, "");
    }
    else
    {
      location.reload();
    }
  }

};

/***** End bsEditLocationOverlay Scripts *****/